import { SearchTerm } from './SearchTerm';

const TransactionSearch: SearchTerm[] = [
    {
        heading: "Event",
        accessor: "event",
        searchOnName: "eventType.trnName",
        translationKey: "event"
    },
    {
        heading: "Display Name",
        accessor: "name",
        searchOnName: "trMasterMstDisplayname",
        translationKey: "displayName"
    },
    {
        heading: "Master Controller",
        accessor: "masterController",
        searchOnName: "trCtrlName",
        translationKey: "masterController"
    },
    {
        heading: "Reader",
        accessor: "reader",
        searchOnName: "trDevName",
        translationKey: "reader"
    },
    {
        heading: "Transaction Type",
        accessor: "transactionType",
        searchOnName: "transackType.trnName",
        translationKey: "transactionType"
    },
    {
        heading: "Building",
        accessor: "building",
        searchOnName: "trBuildingName",
        translationKey: "building"
    },
    {
        heading: "Floor",
        accessor: "floor",
        searchOnName: "trFloorName",
        translationKey: "floor"
    },
    {
        heading: "Zone",
        accessor: "zone",
        searchOnName: "trZoneName",
        translationKey: "zone"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "trSiteName",
        translationKey: "site"
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        searchOnName: "trTagcode",
        translationKey: "cardNumber"
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        searchOnName: "trDevFixedaddr",
        translationKey: "fixedAddress"
    },
    {
        heading: "Logical Address",
        accessor: "logicalAddress",
        searchOnName: "trSla",
        translationKey: "logicalAddress"
    }
    , {
        heading: "Company",
        accessor: "company",
        searchOnName: "trCompName",
        translationKey: "company"
    }
    ,
    {
        heading: "Serial Address",
        accessor: "serialAddress",
        searchOnName: "trDevSerial",
        translationKey: "serialAddress"
    }
    ,
    {
        heading: "Department",
        accessor: "department",
        searchOnName: "trDeptName",
        translationKey: "department"
    },
    {
        heading: "Door",
        accessor: "door",
        searchOnName: "trLocName",
        translationKey: "door"
    },
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "masterByTrMasterId.mstFirstname",
        translationKey: "firstName"
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        searchOnName: "masterByTrMasterId.mstMiddlename",
        translationKey: "secondName"
    },
     {
        heading: "Last Name",
        accessor: "lastName",
        searchOnName: "masterByTrMasterId.mstLastname",
        translationKey: "lastName"
    },
    {
        heading: "Title",
        accessor: "title",
        searchOnName: "masterByTrMasterId.mstTitle",
        translationKey: "title"
    },
    {
        heading: "Gender",
        accessor: "gender",
        searchOnName: "masterByTrMasterId.mstGender",
        translationKey: "gender"
    },
    {
        heading: "Category",
        accessor: "category",
        searchOnName: "masterByTrMasterId.profile.trnName",
        translationKey: "category"
    },
    {
        heading: "Reason Code",
        accessor: "reasonCode",
        searchOnName: "trReasoncode",
        translationKey: "reasonCode"
    },
    {
        heading: "Device Type",
        accessor: "deviceType",
        searchOnName: " unitType.trnName",
        translationKey: "deviceType"
    },
    {
        heading: "Access Type",
        accessor: "access",
        searchOnName: "masterByTrMasterId.masterType.trnName",
        translationKey: "accessType"
    },
]

export default TransactionSearch;
